// extracted by mini-css-extract-plugin
export default {"TableContainer":"Qqc5KpkYWHZRH62AWoMR"};